import { render, staticRenderFns } from "./Topic2Weapon.vue?vue&type=template&id=14c57409&scoped=true"
import script from "./Topic2Weapon.vue?vue&type=script&lang=js"
export * from "./Topic2Weapon.vue?vue&type=script&lang=js"
import style0 from "./Topic2Weapon.vue?vue&type=style&index=0&id=14c57409&prod&lang=scss&scoped=true"
import style1 from "./Topic2Weapon.vue?vue&type=style&index=1&id=14c57409&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c57409",
  null
  
)

export default component.exports